"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Scales02 = function Scales02(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2.5005 13h6m7 0h6m-9.5-6v14m0-14c1.3807 0 2.5-1.1193 2.5-2.5m-2.5 2.5c-1.3807 0-2.5-1.1193-2.5-2.5m-5.5 16.5h16m-16-16.5h5.5m0 0c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5m0 0h5.5M8.8809 14.3364C8.4802 15.8706 7.1186 17 5.5005 17S2.5207 15.8706 2.12 14.3364c-.0327-.1254-.049-.1881-.0507-.4385-.001-.1536.0561-.5075.1053-.653.0802-.2373.167-.3712.3406-.639L5.5005 8l2.9853 4.6059c.1736.2678.2604.4017.3406.639.0491.1455.1062.4994.1052.653-.0016.2504-.018.3131-.0507.4385m13 0C21.4802 15.8706 20.1186 17 18.5005 17s-2.9798-1.1294-3.3805-2.6636c-.0327-.1254-.0491-.1881-.0507-.4385-.0009-.1536.0561-.5075.1053-.653.0802-.2373.167-.3712.3406-.639L18.5005 8l2.9853 4.6059c.1736.2678.2604.4017.3406.639.0491.1455.1062.4994.1052.653-.0016.2504-.0179.3131-.0507.4385"
    })
  }));
};
var _default = exports["default"] = Scales02;